import TemporalConverterBase from '@migrate/utils/date/TemporalConverterBase'
import { convert, LocalDateTime, Temporal } from '@js-joda/core'

export default class LocalDateTimeConverter extends TemporalConverterBase {
  localizationOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }

  private readonly value: LocalDateTime

  constructor(value: LocalDateTime) {
    super()
    this.value = value
  }

  public getValue(): Temporal {
    return this.value
  }

  toNative(): Date {
    return convert(this.value).toDate()
  }
}
